import {
  DrawerHeader,
  DrawerHeaderTitle,
  Drawer,
  Button,
  webLightTheme,
  FluentProvider,
  DrawerBody,
  DrawerFooter,
  DrawerProps,
} from '@fluentui/react-components';
import { Dismiss24Regular } from '@fluentui/react-icons';
import React, { PropsWithChildren } from 'react';

const subheaderContainerStyles: React.CSSProperties = {
  marginLeft: 48,
  marginRight: 48,
  marginBottom: 15,
};

interface ICoherencePanelWithSubheader {
  subheader: JSX.Element;
  headerText: string;
  isOpen?: boolean;
  onDismiss?: (ev?: React.SyntheticEvent<HTMLElement> | KeyboardEvent) => void;
  FooterContent?: JSX.Element;
  closeButtonAriaLabel: string;
  type: DrawerProps['size'];
  isFooterAtBottom?: boolean;
  hasCloseButton?: boolean;
}

const CoherencePanelWithSubheader = ({
  subheader,
  headerText,
  isOpen,
  onDismiss,
  FooterContent,
  type,
  ...props
}: PropsWithChildren<ICoherencePanelWithSubheader>): JSX.Element => {
  return (
    <Drawer
      type="overlay"
      modalType="modal"
      size={type}
      aria-label={headerText}
      separator
      open={isOpen}
      position="end"
      onOpenChange={() => {
        if (onDismiss) {
          onDismiss();
        }
      }}
    >
      <DrawerHeader>
        <DrawerHeaderTitle
          action={
            <Button
              appearance="subtle"
              title={props.closeButtonAriaLabel}
              aria-label={props.closeButtonAriaLabel}
              icon={<Dismiss24Regular />}
              onClick={() => {
                if (onDismiss) {
                  onDismiss();
                }
              }}
            />
          }
        >
          {headerText}
        </DrawerHeaderTitle>
      </DrawerHeader>
      <DrawerBody>
        <div style={subheaderContainerStyles}>{subheader}</div>
        <FluentProvider theme={webLightTheme}>
          {props.children}
          {!props.isFooterAtBottom && FooterContent}
        </FluentProvider>
      </DrawerBody>
      {props.isFooterAtBottom && <DrawerFooter>{FooterContent}</DrawerFooter>}
    </Drawer>
  );
};
export default CoherencePanelWithSubheader;
